import React, { useEffect } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import Sidebar from "./Sidebar";
import apiService from "../core/sevice/detail";
import {
  getMethod,
  postMethod,
} from "../core/sevice/common.api";
import toast, { Toaster } from "react-hot-toast";

function InvestmentSettings_triangular() {

    const initialFormValue = {
        baseorder_limit: "",
        // profit_percentage_sell_min:"",
        // profit_percentage_sell_max:"",
        // profit_callback: "",
        profit_percentage_sell: "",
        balance_lock: "",
        status: ""
        
      }

      const [validationnErr, setvalidationnErr] = useState("");
      const [formValue, setFormValue] = useState(initialFormValue);
      const [baseorder_limitValidate, setbaseorder_limitValidate,baseorder_limitValidateref] = useState(false);
      // const [profit_percentage_sell_minValidate, setprofit_percentage_sell_minValidate,profit_percentage_sell_minValidateref] = useState(false);
      // const [profit_percentage_sell_maxValidate, setprofit_percentage_sell_maxValidate,profit_percentage_sell_maxValidateref] = useState(false);
      // const [profit_callbackValidate, setprofit_callbackValidate,profit_callbackValidateref] = useState(false);

      const [profit_percentage_sell_Validate, setprofit_percentage_sell_Validate,profit_percentage_sell_Validateref] = useState(false);
      const [balance_lockValidate, setbalance_lockValidate,balance_lockValidateref] = useState(false);
      const [statusValidate, setstatusValidate,statusValidateref] = useState(false);

      const [isLoading, setIsLoading] = useState(false);
      const [buttonLoader, setbuttonLoader] = useState(false);

      
      const {
        baseorder_limit,
        // profit_percentage_sell_min,
        // profit_percentage_sell_max,
        // profit_callback,
        profit_percentage_sell,
        balance_lock,
        status
      } = formValue;

      useEffect(() => {
        getInvestment();
  
      }, [0]);
  
      const handleChange = async (e) => {
        e.preventDefault();
        const {name, value} = e.target;
        let formData = {...formValue, ...{[name]: value}};
        setFormValue(formData);
        validate(formData);
      };

      const validate = async (values) => {
        console.log("values====",values.status);
        const errors = {};
  
        if (!values.baseorder_limit) {
          errors.baseorder_limit = "Required field !";
          setbaseorder_limitValidate(true);
        } else {
          setbaseorder_limitValidate(false);
        }

         if (!values.profit_percentage_sell) {
          errors.profit_percentage_sell = "Required field !";
          setprofit_percentage_sell_Validate(true);
        } else {
            setprofit_percentage_sell_Validate(false);
        }
  
        // if (!values.profit_percentage_sell_min) {
        //   errors.profit_percentage_sell_min = "Required field !";
        //   setprofit_percentage_sell_minValidate(true);
        // } else {
        //     setprofit_percentage_sell_minValidate(false);
        // }


        // if (!values.profit_percentage_sell_max) {
        //   errors.profit_percentage_sell_max = "Required field !";
        //   setprofit_percentage_sell_maxValidate(true);
        // } else {
        //     setprofit_percentage_sell_maxValidate(false);
        // }

        // if (!values.profit_callback) {
        //     errors.profit_callback = "Required field !";
        //     setprofit_callbackValidate(true);
        // }
        // else {
        //     setprofit_callbackValidate(false);
        // }

        if (!values.balance_lock) {
          errors.balance_lock = "Required field !";
          setbalance_lockValidate(true);
        }
        else {
          setbalance_lockValidate(false);
        }


        if (values.status == "" || values.status == undefined ) {
            errors.status = "Required field !";
            setstatusValidate(true);
        }
        else {
            setstatusValidate(false);
        }

        setvalidationnErr(errors);
        return errors;
      }

      const getInvestment = async () => {
        try {
          var data = {
            apiUrl: apiService.getInvestment_triangular,
          };
          setIsLoading(true);
          var resp = await getMethod(data);
          
          if (resp.status == true) {
            setIsLoading(false);
            formValue.baseorder_limit = resp.data.baseorder_limit;
            // formValue.profit_percentage_sell_min = resp.data.profit_percentage_sell_min;
            // formValue.profit_percentage_sell_max = resp.data.profit_percentage_sell_max;
            // formValue.profit_callback = resp.data.profit_callback;
            formValue.profit_percentage_sell = resp.data.profit_percentage_sell;
            formValue.balance_lock = resp.data.balance_lock;
            formValue.status = resp.data.status;
          }
        } catch (error) {}
      };

      const formSubmit = async () => {
        validate(formValue);
        if (baseorder_limitValidateref.current === false && 
            // profit_percentage_sell_minValidateref.current === false &&
            // profit_percentage_sell_maxValidateref.current === false &&
            // profit_callbackValidateref.current === false && 
            profit_percentage_sell_Validateref.current === false &&
            balance_lockValidateref.current === false &&
            statusValidateref.current === false
        ) {
          var data = {
            apiUrl: apiService.updateInvestment_triangular,
            payload: formValue,
          };
          setbuttonLoader(true);
          var resp = await postMethod(data);
            if(resp.status == true) {
                toast.success(resp.Message);
                getInvestment();
                setbuttonLoader(false);
            }
            else {
                setbuttonLoader(false);
                toast.error(resp.Message);
            }
        }
      };

  return (
    <div>
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          duration: 4000,
        }}
      />
      <Header />
      <div className="container-fluid enzo-wrapper">
        <div className="row">
        <div className="col-lg-2 pad-left-0 max-md-none bor-right max-d-none">
            <Sidebar />
          </div>
          <div className="col-lg-10 col-sm-9">
            <div className="container-fluid settings-container">
              {isLoading == true ? (
                <>
                  <div className="loader-css">
                    <img
                      src={require("../assets/loader.gif")}
                      alt="loader"
                      className="loader-gif"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="row d-flex justify-content-center align-items-center">
                  <div className="col-lg-8">
                      <div className="setting_blw_col_title">Triangular Investment Settings</div>
                      <div className="setting_blw_col2">

                        <div className="input-settings">
                          <label>Order Limit per trade</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="baseorder_limit"
                              value={baseorder_limit}
                              onChange={handleChange}
                              min = "0"
                            />
                            {baseorder_limitValidateref.current == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.baseorder_limit}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                         <div className="input-settings">
                          <label>Sell Profit Percentage</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="profit_percentage_sell"
                              value={profit_percentage_sell}
                              onChange={handleChange}
                              min = "0"
                            />
                            {profit_percentage_sell_Validateref.current == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.profit_percentage_sell}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        {/* <div className="input-settings">
                          <label>Minimum Sell Profit Percentage</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="profit_percentage_sell_min"
                              value={profit_percentage_sell_min}
                              onChange={handleChange}
                              min = "0"
                            />
                            {profit_percentage_sell_minValidateref.current == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.profit_percentage_sell_min}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                         <div className="input-settings">
                          <label>Maximum Sell Profit Percentage</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="profit_percentage_sell_max"
                              value={profit_percentage_sell_max}
                              onChange={handleChange}
                              min = "0"
                            />
                            {profit_percentage_sell_maxValidateref.current == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.profit_percentage_sell_max}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                          <label>Sell Profit Callback</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="profit_callback"
                              value={profit_callback}
                              onChange={handleChange}
                              min = "0"
                            />
                            {profit_callbackValidateref.current == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.profit_callback}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div> */}

                        <div className="input-settings">
                          <label>Balance Lock</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="balance_lock"
                              value={balance_lock}
                              onChange={handleChange}
                              min = "0"
                            />
                            {balance_lockValidateref.current == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.balance_lock}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                        <label>Status</label>
                        <select
                            className="login-input mt-1"
                            name="status"
                            value={status}
                            onChange={handleChange}>
                            <option value="">Select Status</option>
                            <option value="Active">Active</option>
                            <option value="DeActive">DeActive</option>
                        </select>
                        {statusValidateref.current == true ? (
                            <p className="errorcss">
                            {" "}
                            {validationnErr.status}{" "}
                            </p>
                        ) : (
                            ""
                        )}
                        </div>

                        <div>
                        
                        {buttonLoader == false ? (
                        <button className="login-submit-btn mt-4" onClick={formSubmit}>
                            <span className="login-submit">Submit</span>
                        </button>
                        ) : (
                        <button className="login-submit-btn mt-4">
                            <span className="login-submit">Loading</span>
                        </button>
                        )}
                    
                        
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

    
    </div>
  );
}

export default InvestmentSettings_triangular;
